import { Component, Input } from '@angular/core';

@Component({
    selector: 'progress-overlay',
    templateUrl: './progress-overlay.component.html',
    styleUrls: ['./progress-overlay.component.css']
})

export class ProgressOverlayComponent {
    @Input() progress: number = 0;
    @Input() message: string = '';
}
